export const getEnvVar = (name) => process.env[name];

export const getFirebaseEnvVar = (name) => getEnvVar(`REACT_APP_FIREBASE_${name}`);